import React from 'react';
import { FaAward, FaHandshake, FaChartLine, FaHome } from 'react-icons/fa';
import './About.css';

const About = () => {
  const features = [
    {
      icon: <FaAward />,
      title: 'Expert Team',
      description: 'Experienced professionals with deep market knowledge'
    },
    {
      icon: <FaHandshake />,
      title: 'Client First',
      description: 'Your satisfaction is our top priority'
    },
    {
      icon: <FaChartLine />,
      title: 'Market Insight',
      description: 'Stay updated with latest market trends'
    },
    {
      icon: <FaHome />,
      title: 'Wide Portfolio',
      description: 'Diverse range of properties to choose from'
    }
  ];

  return (
    <section className="about section-padding" id="about">
      <div className="container">
        <div className="section-title">
          <h2>About Jeevika Property Consultant</h2>
          <p>Your Trusted Real Estate Partner Since 2016</p>
        </div>

        <div className="about-content">
          <div className="about-text">
            <h3>Excellence in Real Estate Services</h3>
            <p>
              Established in 2016, Jeevika Property Consultant has been serving the Vasai West 
              community with dedication and expertise. Located opposite Wellness Forever in Vasai West, 
              we specialize in residential and commercial properties, helping clients find their 
              perfect space.
            </p>
            <p>
              With a 4.7/5 rating from our satisfied clients, we bring a wealth of knowledge and 
              commitment to every transaction. Our comprehensive services cover property evaluation, 
              marketing, negotiation, and closing, ensuring a smooth experience from start to finish.
            </p>
          </div>

          <div className="about-features">
            {features.map((feature, index) => (
              <div className="feature-card" key={index}>
                <div className="feature-icon">{feature.icon}</div>
                <h4>{feature.title}</h4>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;